var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 819,
    y: 553,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M843.033 570.255V569.085L849.152 560.13H842.981V558.619H851.3V559.789L845.18 568.744H851.351V570.255H843.033ZM863.594 564.437C863.594 565.679 863.366 566.747 862.912 567.641C862.457 568.532 861.834 569.217 861.042 569.698C860.255 570.175 859.359 570.414 858.355 570.414C857.347 570.414 856.448 570.175 855.656 569.698C854.868 569.217 854.247 568.53 853.792 567.636C853.338 566.742 853.111 565.675 853.111 564.437C853.111 563.194 853.338 562.128 853.792 561.238C854.247 560.344 854.868 559.658 855.656 559.181C856.448 558.7 857.347 558.46 858.355 558.46C859.359 558.46 860.255 558.7 861.042 559.181C861.834 559.658 862.457 560.344 862.912 561.238C863.366 562.128 863.594 563.194 863.594 564.437ZM861.855 564.437C861.855 563.49 861.702 562.693 861.395 562.045C861.092 561.393 860.675 560.901 860.145 560.568C859.618 560.23 859.022 560.062 858.355 560.062C857.684 560.062 857.086 560.23 856.559 560.568C856.033 560.901 855.616 561.393 855.309 562.045C855.006 562.693 854.855 563.49 854.855 564.437C854.855 565.384 855.006 566.183 855.309 566.835C855.616 567.482 856.033 567.975 856.559 568.312C857.086 568.645 857.684 568.812 858.355 568.812C859.022 568.812 859.618 568.645 860.145 568.312C860.675 567.975 861.092 567.482 861.395 566.835C861.702 566.183 861.855 565.384 861.855 564.437ZM875.655 558.619V570.255H874.041L868.126 561.721H868.018V570.255H866.262V558.619H867.887L873.808 567.164H873.916V558.619H875.655ZM878.696 570.255V558.619H885.991V560.13H880.451V563.675H885.61V565.181H880.451V568.744H886.059V570.255H878.696ZM897.786 558.619V570.255H896.025V560.38H895.957L893.173 562.198V560.516L896.076 558.619H897.786Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 870.935,
    cy: 643.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.935,
    cy: 643.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.935,
    cy: 643.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone1);
export default __webpack_public_path__ + "static/media/3d_zone_1.5cfe66b9618d8764c3e3579d14607d83.svg";
export { ForwardRef as ReactComponent };